import { Modal, Button } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { APISERVICE } from '../../../services/api.service'

const initialPeriodos = { 0: false, 1: false, 2: false, 3: false, 4: false }
const currentYear = new Date().getFullYear()
const previousYear = currentYear - 1

const ModalNewPeriod = ({ show, onHide, onAccept }) => {
    const [periodos, setPeriodos] = useState(initialPeriodos)
    const [disabled, setDisabled] = useState({ 0: false, 1: false, 2: false, 3: false, 4: false })
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [gestion, setGestion] = useState(currentYear)

    useEffect(() => {
        if (show) {
            verifyPeriods()
        }
    }, [show, gestion])

    const verifyPeriods = async () => {
        const url = 'facultad/verify-periods'
        const { success, data } = await APISERVICE.get(url, `?periodos=0,1,2,3,4,5&gestion=${gestion}`)
        if (success) {
            const _disabled = ['0', '1', '2', '3', '4'].reduce(
                (carry, periodo) => {
                    if (!data.includes(periodo)) {
                        carry[periodo] = true
                    }
                    return carry
                },
                { 0: false, 1: false, 2: false, 3: false, 4: false },
            )
            setDisabled(_disabled)
        }
    }
    const handleChange = (e) => {
        error && setError('')
        if (!disabled[e.target.name]) {
            setPeriodos({ ...periodos, [e.target.name]: e.target.checked })
        }
    }
    const handleChangeGestion = ({ target }) => {
        setGestion(target.value)
        setPeriodos(initialPeriodos)
    }
    const handleAcceptButton = async () => {
        const _periodos = Object.keys(periodos).reduce((carry, value) => {
            if (periodos[value]) {
                carry = carry ? `${carry},${value}` : value
            }
            return carry
        }, '')
        if (_periodos) {
            error && setError('')
            if (onAccept) {
                setLoading(true)
                const success = await onAccept(_periodos, gestion)
                success && clearPeriodos()
            }
        } else {
            setError('Debe seleccionar por lo menos un periodo.')
        }
        setLoading(false)
    }
    const handleCancel = () => {
        onHide && onHide()
        clearPeriodos()
    }
    const clearPeriodos = () => setPeriodos(initialPeriodos)

    return (
        <Modal show={show} size='sm' onExited={() => error && setError('')} centered>
            <Modal.Header>
                <span className='h4 mb-0'>Crear periodos</span>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div className='d-flex align-items-center gap-2 mb-3'>
                        <label>Gestión:</label>
                        <select className='form-select' value={gestion} onChange={handleChangeGestion}>
                            <option value={currentYear}>{currentYear}</option>
                            <option value={previousYear}>{previousYear}</option>
                        </select>
                    </div>
                    <CustomCheck
                        name='0'
                        label='0 - Anual'
                        checked={periodos['0']}
                        disabled={disabled['0']}
                        onChange={handleChange}
                    />
                    <CustomCheck
                        name='1'
                        label='1 - Primer Semestre'
                        checked={periodos['1']}
                        disabled={disabled['1']}
                        onChange={handleChange}
                    />
                    <CustomCheck
                        name='2'
                        label='2 - Segundo Semestre'
                        checked={periodos['2']}
                        disabled={disabled['2']}
                        onChange={handleChange}
                    />
                    <CustomCheck
                        name='3'
                        label='3 - Verano'
                        checked={periodos['3']}
                        disabled={disabled['3']}
                        onChange={handleChange}
                    />
                    <CustomCheck
                        name='4'
                        label='4 - Invierno'
                        checked={periodos['4']}
                        disabled={disabled['4']}
                        onChange={handleChange}
                    />
                    {!!error && <div className='d-block invalid-feedback'>{error}</div>}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCancel} variant='danger' disabled={loading}>
                    Cancelar
                </Button>
                <Button onClick={handleAcceptButton} variant='blue' disabled={loading}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function CustomCheck({ label, ...props }) {
    return (
        <div className='d-flex align-items-center mb-2'>
            <input
                {...props}
                className='form-check-input mt-0'
                type='checkbox'
                style={{ width: '1.25rem', height: '1.25rem' }}
            />
            <label className='form-check-label ms-2'>{label}</label>
        </div>
    )
}

export default ModalNewPeriod
